/**
 * @typedef {import('./TicketSelector').PricetypeQuantities} PricetypeQuantities
 */

class PreselectedPricetypeQuantities {
  /**
   * @param {PricetypeQuantities} pricetypeQuantities
   */
  constructor(pricetypeQuantities) {
    this.pricetypeQuantities = pricetypeQuantities;
  }

  getData() {
    const allPricetypeQuantities = this.pricetypeQuantities;

    const totalQuantitySelected = allPricetypeQuantities
      .reduce((sum, { quantity }) => sum + quantity, 0);

    return {
      isEditablePriceAvailable: false,
      isSelectionValid: true,
      totalQuantitySelected,
      allPricetypeQuantities,
      maxQuantity: Infinity,
    };
  }
}

export default PreselectedPricetypeQuantities;
